import { render, staticRenderFns } from "./NoticeMessage.vue?vue&type=template&id=495f1354&scoped=true&"
import script from "./NoticeMessage.vue?vue&type=script&lang=js&"
export * from "./NoticeMessage.vue?vue&type=script&lang=js&"
import style0 from "./NoticeMessage.vue?vue&type=style&index=0&id=495f1354&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495f1354",
  null
  
)

export default component.exports